// extracted by mini-css-extract-plugin
export var equalColumn = "_gz-0";